import { User, UserRole } from '@prisma/client';
import RolesUtils from './roles.utils';

export default class UsersUtils {
  static hasRoles(user: User | undefined, ...roles: UserRole[]): boolean {
    if (user === undefined) return false;
    return UsersUtils.rolesContains(user.roles, ...roles);
  }

  // This returns [true] if at least one of the [elems] is found in [roles]
  static rolesContains(roles: UserRole[], ...elems: UserRole[]): boolean {
    for (const el of elems) {
      if (roles.includes(el)) {
        return true;
      }
    }
    return false;
  }

  static hasPrimaryRoles(user: User | undefined): boolean {
    return this.rolesContains(user?.roles ?? [], ...RolesUtils.primaryRoles);
  }

  static hasSecondaryRoles(user: User | undefined): boolean {
    return !this.hasPrimaryRoles(user);
  }
}
